








































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { contributeCompanyList, contributeHide, contributeCreate } from '@/api/contribute';
import selectMember from '@/components/project/selectMember.vue';
import moment from 'moment';
import { roundSimpleList } from '@/api/common';

const columns = [
  {
    title: '项目名称',
    dataIndex: 'companyName',
    key: 'companyName',
    width: '30%'
  },
  {
    title: '轮次',
    dataIndex: 'roundName',
    key: 'roundName',
    customRender: data => {
      return data + '轮';
    }
  },
  {
    title: 'DL',
    dataIndex: 'dlname',
    align: 'center',
    key: 'dlname'
  },
  {
    title: '交割时间',
    dataIndex: 'time',
    key: 'time',
    align: 'center',
    width: '20%'
  },
  {
    title: '操作',
    align: 'center',
    scopedSlots: {
      customRender: 'action'
    }
  }
];

@Component({ components: { selectMember } })
class CreateContribution extends Vue {
  columns: any[] = columns;
  data: any[] = [];
  keyword: string = '';
  total: number = 0;
  pageSize: number = 10;
  showModal: string = '';
  companyObj: object = {};
  DLUserlist: any[] = [];
  contributorList: any[] = [];
  contributorRoleList: any[] = ['source', 'sponsor'];
  page: number = 1;
  roundList: any[] = [];

  created() {
    this.getList();
  }

  async getList() {
    try {
      this.data = [];
      let res = await contributeCompanyList({ page: this.page, pageSize: this.pageSize, companyName: this.keyword });
      if (res.code === 200) {
        this.data =
          res.data.list.map(_ => {
            return {
              ..._,
              time: moment(_.joinTime).format('YYYY-MM') || '',
              joinTime: moment(_.joinTime, 'YYYY-MM')
            };
          }) || [];
        this.total = res.data.total;
      }
    } catch (err) {
      console.log(err);
    }
  }

  handleSearch() {
    this.page = 1;
    this.getList();
  }

  onChange(page, pageSize) {
    this.page = page;
    this.getList();
  }

  async hideContribute() {
    try {
      let res = await contributeHide({ contributeId: this.companyObj['id'] });
      if (res.code === 200) {
        this.$message.success('操作成功');
        this.showModal = '';
        this.getList();
      }
    } catch (err) {
      console.log(err);
    }
  }

  async showCreateModal(data) {
    try {
      this.showModal = 'contributeCreateTable';
      this.companyObj = { ...data };
      this.DLUserlist = [{ id: data.DL, nickname: data.dlname }];
      let res = await roundSimpleList();
      if (res.code === 200) {
        this.roundList = res.data || [];
      }
    } catch (err) {
      console.log(err);
    }
  }

  closeCreateModal() {
    this.showModal = '';
    this.companyObj = {};
    this.DLUserlist = [];
    this.contributorList = [];
  }

  choseDLId(val) {
    this.DLUserlist = val;
  }

  delDLId(val) {
    this.DLUserlist = [];
  }

  addContributor() {
    this.contributorList.push({ contributor: [], role: 0 });
  }

  choseContributorId(index, val) {
    this.$set(this.contributorList[index], 'contributor', val);
  }

  delContributorId(index, val) {
    this.$set(this.contributorList[index], 'contributor', []);
  }

  validContribute() {
    if (!this.DLUserlist || this.DLUserlist.length <= 0) {
      this.$message.error('DL不能为空');
      return false;
    }
    return true;
  }

  deleteContribute(index) {
    this.contributorList.splice(index, 1);
  }

  async createContribution() {
    if (this.validContribute()) {
      try {
        let contributorList = this.contributorList
          .filter(_ => {
            return _.contributor[0];
          })
          .map(_ => {
            if (_.contributor[0]) {
              return {
                id: _.contributor[0].id,
                role: _.role
              };
            }
          });
        let res = await contributeCreate({
          id: this.companyObj['id'],
          DL: this.DLUserlist[0].id,
          contributorList: contributorList,
          round: this.companyObj['round'],
          joinTime: moment(this.companyObj['joinTime']).valueOf()
        });
        if (res.code === 200) {
          this.$message.success('创建成功');
          this.closeCreateModal();
          this.page = 1;
          this.getList();
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  showHideModal(data) {
    this.showModal = 'hideNotice';
    this.companyObj = data;
  }

  handleChange(val) {
    this.companyObj['round'] = val;
  }
}
export default CreateContribution;
